import React, { useState } from 'react';
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";
import { IoMdAdd } from "react-icons/io";
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import Toast from '../../../Modals/toast/Toast';
import TwoStepProgress from './modals/TowStepPrgress';
import Step1 from './Component/Step1';
import Step2 from './Component/Step2';
import AdsService from '../../../services/Ads';
import FileService from '../../../services/file';


const RegisterAds = () => {
  const [Image, setImage] = useState([]);

  const handleSubmit = async () => {
    setLoadingBtn(true);
    try {
      let imageIds = Array.isArray(Image) ? [...Image] : [];

      if (formData.images && formData.images.length) {
        for (let i = 0; i < formData.images.length; i++) {
          const item = formData.images[i];
          const hasId = imageIds[i] !== undefined && imageIds[i] !== null && imageIds[i] !== "";
          if (!hasId && item instanceof File) {
            try {
              const fd = new FormData();
              fd.append("file", item);
              const resp = await FileService.uploadFile(fd);
              const res = resp && resp.data ? resp.data : resp;
              const id = res?.message?.id || res?.message?._id || res?.id || res?._id || (typeof res === "string" ? res : null);
              imageIds[i] = id;
            } catch (err) {
              console.warn("Fallback upload failed for index", i, err);
              imageIds[i] = null;
            }
          }
        }
      }

      const imagesToSend = (imageIds || []).filter((v) => v !== undefined && v !== null && v !== "");

      setImage(imagesToSend);
      const dataToSend = {
        type: formData.dealType === "فروشی" ? "sales" : "rent",
        city: formData.city,
        image: imagesToSend,
        car: formData.model,
        price: String(formData.price),
        description: formData.description || "",
        title: formData.title,
        productionYear:formData.year,

      };

      console.log("Data to send:", dataToSend);

      const response = await AdsService.registerAd(dataToSend);

      setErrors({ submit: null });
      navigate("/ads/dashboard");

    } catch (error) {

      let errorMessage = "خطا در ثبت آگهی. لطفاً دوباره تلاش کنید.";
      const resp = error?.response || error;

      if (resp?.status === 400) {
        errorMessage = "اطلاعات وارد شده نامعتبر است. لطفاً بررسی کنید.";
      }
       else if (resp?.status === 500) {
        errorMessage = "خطای سرور. لطفاً بعداً تلاش کنید.";
        console.log("Server error details:", resp?.data || error?.data || error);
      }

      setErrors({ submit: errorMessage });

    } 
    finally {
      setLoadingBtn(false);
    }
  };





  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);

  const [formData, setFormData] = useState({
    dealType: "",
    model: "",
    year: "",
    title: "",
    price: "",
    city: "",
    description: "",
    image: [],
  });

  const [errors, setErrors] = useState({});
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [shake, setShake] = useState(false);

  const validateStep1 = () => {
    let newErrors = {};
    if (!formData.dealType) newErrors.dealType = "نوع معامله الزامی است";
    if (!formData.model) newErrors.model = "مدل الزامی است";
    if (!formData.year) newErrors.year = "سال تولید الزامی است";
    if (!formData.title) newErrors.title = "عنوان الزامی است";
    // if (!formData.color) newErrors.color = "رنگ الزامی است";
    if (!formData.price) newErrors.price = "قیمت الزامی است";
    if (!formData.city) newErrors.city = "شهر الزامی است";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    let newErrors = {};
    const hasImages = Image && Image.some(img => img !== null);
    if (!hasImages) {
      newErrors.images = "حداقل یک عکس باید آپلود کنید";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (currentStep === 1) {
      if (!validateStep1()) {
        setShake(true);
        console.log("Validation errors found:", errors);
        setTimeout(() => setShake(false), 500);
        return;
      }
      setCurrentStep(2);
    } else {

      if (!validateStep2()) {
        setShake(true);
        setTimeout(() => setShake(false), 500);
        return;
      }
      await handleSubmit();
    }
  };

  return (
    <>
      <Toast />
      <div className="w-full flex justify-center items-center flex-col gap-10 min-h-screen py-10 lg:px-10 px-5">
        {currentStep === 1 && (
          <Step1
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            shake={shake}
            setCurrentStep={setCurrentStep}
          />
        )}
        {currentStep === 2 && (
          <Step2
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setImage={setImage}
          />
        )}

        {/* footer */}
        <motion.section
          className="flex justify-start items-start flex-col gap-5 max-w-6xl w-full mx-auto"
          initial="hidden"
          animate="show"
          dir="rtl"
        >
          {/* نمایش خطای کلی */}
          {errors.submit && (
            <div className="w-full text-start">
              <span className="text-red-500 text-sm">{errors.submit}</span>
            </div>
          )}
          <motion.div
            className="w-full border-t-[1px] mt-6 border-gray-300 py-4 flex flex-col md:flex-row justify-between items-center gap-4"
          >
            <div className="flex flex-col gap-1 py-2 w-full md:w-auto">
              <TwoStepProgress currentStep={currentStep} />
            </div>

            <div className="flex gap-3 w-full md:w-auto justify-end">
              {currentStep === 2 && (
                <button
                  onClick={() => setCurrentStep(1)}
                  disabled={loadingBtn}
                  className={`w-full md:w-[140px] h-[40px] bg-transparent border border-special text-special rounded-lg flex items-center justify-center gap-2 transition-all ${shake ? "animate-shake" : ""
                    } ${loadingBtn ? "opacity-60 cursor-not-allowed" : ""}`}
                >
                  <GoChevronRight size={15} />
                  <span className="hidden md:inline">مرحله قبل</span>
                  <span className="md:hidden">بازگشت</span>

                </button>
              )}

              <button
                onClick={handleNext}
                disabled={loadingBtn}
                className={`w-full md:w-[140px] h-[40px] bg-special text-white rounded-lg flex items-center justify-center gap-2 transition-all ${shake ? "animate-shake" : ""
                  } ${loadingBtn ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                {currentStep === 1 ? (
                  <>
                    <span className="hidden md:inline">مرحله بعد</span>
                    <span className="md:hidden">ادامه</span>
                    <GoChevronLeft size={15} />
                  </>
                ) : (
                  <>
                    <span>
                      {loadingBtn ? "منتظر بمانید..." : "ثبت"}
                    </span>
                    <IoMdAdd />

                  </>
                )}
              </button>
            </div>


          </motion.div>
        </motion.section>
      </div>
    </>
  );
};

export default RegisterAds;


